module.exports = __webpack_public_path__ + "img/swiper_1.13f020a9.png";